export default{
    htmlTitle: '智慧工程管理平台',
    BASE_URL: 'http://122.152.198.146:6789/',//后端接口url
    // BASE_URL: 'http://localhost:6789',//后端接口url
    // BASE_URL: 'http://118.122.238.36:8872/api/',//后端接口url
    // IP: 'http://dam.wedam.com.cn/chuanda',    //  前端ip,目前用于二维码地址
    HOST: 'localhost',
    Main: '/dataMonitor',
    REG: {
        // 身份证正则
        ID_CARD: /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/,
        //中国大陆手机正则
        MOBILE: /^1[3456789]\d{9}$/,
        //正整数和0
        INT: /^[1-9]\d*|0$/,
        NUM:/^[1-9]\d*\,\d*|[1-9]\d*$/,
        CLEAR_SPACE: /\s/g,
    }
}


// WEBPACK FOOTER //
// ./src/views/common/global.js